import { gql } from '@apollo/client';
import { USER_FIELDS } from '../fragments/user_fields';

export const MeQuery = gql`
  ${USER_FIELDS}
  query me {
    me {
      ...UserFields
    }
  }
`;
